// extracted by mini-css-extract-plugin
export var Container = "default-module--Container--22LbZ";
export var ErrorCode = "default-module--ErrorCode--3gWwa";
export var Title = "default-module--Title--3t8w0";
export var Description = "default-module--Description--1KSi_";